import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/reterritorializacao`

    return {
        usuario: {
            autocomplete(queryParms = {}) {
                return repository.get(`${baseUrl}/autocomplete-usuario?${urlUtil.serialize(queryParms)}`)
            },
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
    }
}
